import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { Button } from 'primereact/button'

import Overlay from '../../../Overlay'

import './Delete.css'

const CLASS = 'insights-portal-subject-delete'

const Delete = props => {
  const index = props.index ?? -1

  const editor = useMemo(() => props.editor || {}, [props.editor])

  const show = useMemo(
    () => index === editor.itemIndex && 'delete' === editor.type,
    [editor.itemIndex, editor.type, index]
  )

  const onPressYes = () => {
    if (props.onEditorChange) {
      props.onEditorChange({ action: 'save' })
    }
  }

  const onPressNo = () => {
    if (props.onEditorChange) {
      props.onEditorChange({})
    }
  }

  const onKeyDown = event => {
    if (props.onEditorChange && 'Escape' === event.key) {
      props.onEditorChange({})
    }
  }

  const onOuterClick = () => {
    if (props.onEditorChange) {
      props.onEditorChange({})
    }
  }

  return (
    <Overlay className={CLASS} show={show} onKeyDown={onKeyDown} onOuterClick={onOuterClick}>
      <div className={`${CLASS}-text`}>Permanently delete concept?</div>
      <Button className={`${CLASS}-button ${CLASS}-button-yes`} onClick={onPressYes}>
        YES
      </Button>
      <Button className={`${CLASS}-button ${CLASS}-button-no`} onClick={onPressNo}>
        NO
      </Button>
    </Overlay>
  )
}

Delete.propTypes = {
  className: PropTypes.string,
  index: PropTypes.number,
  editor: PropTypes.object,
  onEditorChange: PropTypes.func
}

export default Delete
